import { Button, ButtonProps } from '@spotify-internal/encore-web';

const SectionButton = ({
  size = 'small',
  variant = 'tertiary',
  ...props
}: ButtonProps) => <Button size={size} variant={variant} data-track-source-anchor="769e8d407f;section-button" {...props} />;

export default SectionButton;
